import { Component, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { lastValueFrom } from 'rxjs';
import {
  BfluenceIntegrityControllerService,
  CreatedTransactionBenefit
} from 'src/app/admin-api';
import { TableColumn, TableComponent } from 'src/app/components/table';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-created-transaction-benefit',
  templateUrl: './created-transaction-benefit.component.html',
  styleUrl: './created-transaction-benefit.component.scss',
  providers: [ConfirmationService, MessageService]
})
export class CreatedTransactionBenefitComponent {
  @ViewChild(TableComponent) table: TableComponent;

  columns: Array<TableColumn> = [
    new TableColumn('', '', false, 'checkbox'),
    new TableColumn(
      'CreditCardPaymentId',
      'creditCardPaymentId',
      true,
      'number'
    ),
    new TableColumn(
      'SubscriberId',
      'subscriberId',
      true,
      'number',
      '/users/subscribers/',
      'subscriberId'
    )
  ];

  constructor(
    public bfluenceIntegrityService: BfluenceIntegrityControllerService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {}

  markAsResolved(elements: Array<CreatedTransactionBenefit>): void {
    this.confirmationService.confirm({
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      rejectButtonStyleClass: 'p-button-danger',
      message: 'Deseja ajustar esta(s) transação(ões)?',
      header: 'Ajustar Benefícios',
      accept: async () => {
        LoaderService.showLoader();
        try {
          await lastValueFrom(
            this.bfluenceIntegrityService.fixCreatedTransactionBenefits(
              elements
            )
          );
          await this.table.refresh(true);
          this.messageService.add({
            summary: 'Sucesso',
            detail: elements.length + ' marcado(s) como resolvido(s)',
            severity: 'success'
          });
          LoaderService.showLoader(false);
        } catch (error) {
          LoaderService.showLoader(false);
          AppDialogService.showErrorDialog(error);
        }
      }
    });
  }
}
